import { createSelector } from 'reselect';

export const getStep = state => state.getIn(['withdraw', 'step']);
export const getAmount = state => state.getIn(['withdraw', 'amount']);
export const getHistory = state => state.getIn(['withdraw', 'history']);
export const isHistoryLoaded = state => state.getIn(['withdraw', 'historyLoaded']);
export const isPendingWithdrawal = state => state.getIn(['withdraw', 'pendingWithdrawal']);

export const getLatestHistoryItem = createSelector(
  getHistory,
  history => history.first()
);
